import { render, staticRenderFns } from "./ElementStudioRangeOptions.vue?vue&type=template&id=04a8f67a&"
import script from "./ElementStudioRangeOptions.vue?vue&type=script&lang=ts&"
export * from "./ElementStudioRangeOptions.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports